import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from '@apollo/client';
export var forgotPassword = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation forgotPassword($email: String!, $code: String!) {\n    forgotPassword(email: $email, code: $code) {\n      message\n    }\n  }\n"])));